import controller from './header-controller';
import template from './header.html'

const HeaderComponent = {
    controller,
    template
};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./app/common/header/header-component.js